import { render, staticRenderFns } from "./Announcements.pug?vue&type=template&id=7b92a1da&scoped=true&lang=pug&"
import script from "./Announcements.vue?vue&type=script&lang=js&"
export * from "./Announcements.vue?vue&type=script&lang=js&"
import style0 from "./Announcements.scss?vue&type=style&index=0&id=7b92a1da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b92a1da",
  null
  
)

export default component.exports